import { render, staticRenderFns } from "./BulkLiquidationManagement.vue?vue&type=template&id=a0aa87dc&scoped=true"
import script from "./BulkLiquidationManagement.vue?vue&type=script&lang=ts"
export * from "./BulkLiquidationManagement.vue?vue&type=script&lang=ts"
import style0 from "./BulkLiquidationManagement.vue?vue&type=style&index=0&id=a0aa87dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aa87dc",
  null
  
)

export default component.exports